import AbstractFinanceManage from './AbstractFinanceManage'
import { getSiJobDetail } from '@/api/SeaImport/siBooking'
import { getReJobDetail } from '@/api/railwayExport/reBooking'
import { cacheName, cache } from '@/utils/cacheManager'
import {
  batchUpdateChargeState,
  batchUpdateAccountingDate,
  batchUpdateChargeAccountingDate,
  wkVerifyRollbackPush
} from '@/api/clearing/financeManage'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { Assert } from '@/utils/validate'
import { Job } from '@/class/model/booking/Job'
import { RailwayExportJob } from '@/class/model/booking/RailwayExportJob'
import { SeaImportJob } from '@/class/model/booking/SeaImportJob'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import { AirImportJob } from '@/class/model/booking/AirImportJob'
import { AirExportJob } from '@/class/model/booking/AirExportJob'
import * as ChargeUtils from '@/class/cargo/model/utils/ChargeUtils'
import { updateSapStatus, sendSapMessageByCharge, sendHecMessageByCharge } from '@/api/clearing/charge'
import * as ContainerLoadType from '@/class/cargo/model/parameters/ContainerLoadType'
import * as CargoSource from '@/class/cargo/model/parameters/CargoSource'
import * as ImportConstants from '@/class/cargo/model/parameters/ImportConstants'
import * as AirExportConstants from '@/class/cargo/model/parameters/AirExportConstants'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { IntegratedJob } from '@/class/model/booking/IntegratedJob'
import { checkCancelAudit } from '@/api/booking/job'
import ArchiveEffectUtils from '@/class/cargo/model/utils/ArchiveEffectUtils'
import { getEffectConfig } from '@/api/sysManage/baseConfig/financialArchivingSetting'
import { getUserInfo } from '@/utils/auth'

export default class FinanceDetailHP extends AbstractFinanceManage {
  _sapChargeList = []

  get sapChargeList() {
    return this._sapChargeList
  }

  set sapChargeList(value) {
    this._sapChargeList = value
  }

  constructor(view) {
    super(view)
    // this.seContext = new SeContext(new SeParentContext())
  }

  // getSeContext() {
  //   return new SeContext(new SeParentContext())
  // }
  async getAndSetJobDetail() {
    // 因海出页签的内部特殊性，海出单独处理
    if (this._view.lob === 'SE') {
      const seJob = { uuid: this._view.jobUuid }
      await new SeaExportJob(seJob).loadJobRelated({
        job: true,
        seaEQ: true,
        lclSlaves: this._view.masterFlag,
        charges: this._view.masterFlag,
        warehouseIn: this._view.masterFlag,
        warehouseInfo: true,
        trucking: true,
        lclMaster: !this._view.masterFlag,
        seaCargoDoc: !this._view.masterFlag,
        containerUsages: true,
        containers: true,
        cargoBulkDetail: !this._view.masterFlag,
        surchargeTerms: !this._view.masterFlag,
        orderCenterMode: this._view.useOrderCenterMode,
        cooperateBranchId: this._view.cooperateBranchId,
        jobWarehouseNos: this._view.jingyuWarehouse
      })
      this._view.job = seJob
      return
    }
    if (this._view.lob === 'SI') {
      const siJob = { uuid: this._view.jobUuid }
      await new SeaImportJob(siJob).loadJobRelated({
        job: true,
        seaEQ: true,
        lclSlaves: this._view.masterFlag,
        charges: true,
        warehouseIn: this._view.masterFlag,
        warehouseInfo: true,
        trucking: true,
        lclMaster: !this._view.masterFlag,
        seaCargoDoc: !this._view.masterFlag,
        containerUsages: true,
        containers: true,
        surchargeTerms: !this._view.masterFlag
      })
      this._view.job = siJob
      return
    }
    if (this._view.lob === 'AE') {
      const aeJob = { uuid: this._view.jobUuid }
      await new AirExportJob(aeJob).loadJobRelated({
        job: true,
        cargoDoc: true,
        airCargoDoc: true,
        lclSlaves: this._view.masterFlag,
        charges: true,
        warehouseIn: this._view.masterFlag,
        warehouseInfo: true,
        trucking: true,
        lclMaster: !this._view.masterFlag,
        containerUsages: true,
        containers: true
      })
      this._view.job = aeJob
      return
    }
    if (this._view.lob === 'AI') {
      const aiJob = { uuid: this._view.jobUuid }
      await new AirImportJob(aiJob).loadJobRelated({
        job: true,
        masterJob: !this._view.masterFlag,
        lclSlaves: this._view.masterFlag
      })
      this._view.job = aiJob
      return
    }
    if (this._view.lob === 'RE' || this._view.lob === 'RI') {
      const reJob = { uuid: this._view.jobUuid }
      await new RailwayExportJob(reJob).loadJobRelated({
        job: true,
        seaEQ: true,
        lclSlaves: this._view.masterFlag,
        lclMaster: !this._view.masterFlag,
        charges: true,
        warehouseIn: true,
        warehouseInfo: true,
        trucking: true,
        containerUsages: true,
        containers: true,
        cargoBulkDetail: !this._view.masterFlag,
        surchargeTerms: !this._view.masterFlag
      })
      this._view.job = reJob
      return
    }
    if (this._view.lob === 'IE') {
      const ieJob = { uuid: this._view.jobUuid }
      await new IntegratedJob(ieJob).loadJobRelated({
        job: true,
        seaEQ: true,
        charges: true,
        warehouseIn: true,
        warehouseInfo: true,
        trucking: true,
        truckingInfoPod: true,
        containerUsages: true,
        containers: true
      })
      this._view.job = ieJob
      return
    }
    let requestApi = null
    let JobClazz = null
    switch (this._view.lob) {
      /* case 'AE':
        requestApi = getAeJobDetail
        JobClazz = AirExportJob
        break
      case 'AI':
        requestApi = getAiJobDetail
        JobClazz = AirImportJob
        break*/
      case 'SI':
        requestApi = getSiJobDetail
        JobClazz = SeaImportJob
        break
      case 'RE':
      case 'RI':
        requestApi = getReJobDetail
        JobClazz = RailwayExportJob
        break
    }
    if (requestApi) {
      await requestApi(this._view.jobUuid).then(async res => {
        // todo ceshi
        let job = {}
        if (this._view.masterFlag) {
          job = { ...res.data.master, lclSlaves: [...res.data.lclSlaves], seaEQ: [... res.data.seaEqVOList] }
        } else {
          job = { ...res.data.lclSlaves[0], master: { ...res.data.master }, lclSlaves: [], seaEQ: [... res.data.seaEqVOList] }
        }
        if (this._view.lob === 'RE' || this._view.lob === 'RI') {
          const reJob = { uuid: this._view.jobUuid }
          await new RailwayExportJob(reJob).loadJobRelated({
            job: true,
            seaEQ: true,
            lclSlaves: this._view.masterFlag,
            lclMaster: !this._view.masterFlag,
            charges: this._view.masterFlag,
            warehouseIn: this._view.masterFlag,
            warehouseInfo: this._view.masterFlag,
            trucking: this._view.masterFlag,
            seaCargoDoc: !this._view.masterFlag,
            containerUsages: !this._view.masterFlag,
            containers: !this._view.masterFlag,
            cargoBulkDetail: !this._view.masterFlag,
            surchargeTerms: !this._view.masterFlag
          })
          Object.assign(this._view.job, reJob)
          return
        }
        this._view.job = new JobClazz(job).fillDefaultValue().getData()
      })
    }
  }
  // 导出全部
  async exportExcelAllClickHandler() {
    this._view.$emit('exportAll2Excel', 'detail')
  }
  // 业务调整
  buissInfoClickHandler() {
    // 财务归档生效判断
    const warnflag = ArchiveEffectUtils.checkArchiveEffect(this.financeBtnGroupView.job)
    if (warnflag) {
      this.$message.warning(this.$t('CargoMsg.NOT_OPERATIONAL'))
      return
    }
    // todo
    this.financeBtnGroupView.showBusinessAdjustDialog = true
  }
  buissInfoClickHandlerConfirmCB() {
    this.refresh()
  }
  refresh() {
    // todo job状态变更后，进行异步刷新
    this._view.showDetail(this._view.job)
    // todo 定位到当前页签
  }
  // 修改费用财务日期
  async updateChargeAccountingDateClickHandler() {
    // 财务归档生效判断
    const warnflag = ArchiveEffectUtils.checkArchiveEffect(this.financeBtnGroupView.job)
    if (warnflag) {
      this.$message.warning(this.$t('CargoMsg.NOT_OPERATIONAL'))
      return
    }
    // 获取 选中的费用记录
    const chooseCharges = this._view.$refs['tabCharges'].tabChargesHP.getAllSelectedRows(false)
    if (!chooseCharges || chooseCharges.length <= 0) {
      this.$message.warning(this.$t('Message.PleaseSelectCharges'))
      return
    }
    this.financeBtnGroupView.showUpdateChargeAccountingDateDialog = true
  }
  async updateChargeAccountingDateConfirmCB(accountingDate) {
    // todo 修改选中费用的 财务日期 --- 可以结合修改财务日期的逻辑一起处理
    // await this.$confirm('确定要修改单笔费用财务日期吗？', '提示')
    this.$confirm(this.$t('Clearing.ConfirmTheSingleCostDate'), this.$t('common.tips.prompt'), {
      confirmButtonText: this.$t('common.btn.yes'),
      cancelButtonText: this.$t('common.btn.no'),
      type: 'warning'
    }).then(() => {
      const chooseCharges = this._view.$refs['tabCharges'].tabChargesHP.getAllSelectedRows(false)
      const chargeUuids = chooseCharges.map(item => item.uuid)
      this.loading()
      batchUpdateChargeAccountingDate(chargeUuids, accountingDate, this._view.location).then(res => {
        this.$message.success(this.$t('Clearing.CostFinancialDateModificationSuccessful'))
        this.financeBtnGroupView.showUpdateChargeAccountingDateDialog = false
        this.refresh()
      }).finally(() => {
        this.closeLoading()
      })
    }).catch(() => {
    })
  }
  // 修改财务日期
  async updateAccountingDateClickHandler() {
    // 财务归档生效判断
    const warnflag = ArchiveEffectUtils.checkArchiveEffect(this.financeBtnGroupView.job)
    if (warnflag) {
      this.$message.warning(this.$t('CargoMsg.NOT_OPERATIONAL'))
      return
    }
    this.financeBtnGroupView.showUpdateAccountingDateDialog = true
  }
  async updateAccountingDateConfirmCB(accountingDate) {
    this.financeBtnGroupView.accountingPageDate = new Date(accountingDate)
    await this.$confirm(this.$t('Clearing.ConfirmModifyTheFinancialDate'), this.$t('CargoMsg.Cargo_Tips'), { type: 'warning' })
    const job = this.financeBtnGroupView.job
    // todo 主票或下票关联的费用的日期全部更改为 accountingDate（需要判断是否关账） 放到后台处理
    this.loading()
    batchUpdateAccountingDate([job.uuid], accountingDate, this._view.location).then(res => {
      this.$message.success('财务日期修改成功')
      this.financeBtnGroupView.showUpdateAccountingDateDialog = false
      this.refresh()
    }).finally(() => {
      this.closeLoading()
    })
  }
  async cancelAccountingDate(pageDate) {
    this.financeBtnGroupView.accountingPageDate = new Date(pageDate)
  }
  // 取消计提
  async cancelProvisionedClickHandler() {
    const list = [this.financeBtnGroupView.job]
    // 查询归档生效配置
    let effectConfig = {}
    await getEffectConfig(this.$store.getters.currentOfficeId).then(res => {
      if (res.data) {
        effectConfig = res.data
      }
    })
    if (effectConfig && effectConfig.modifyAccrual === 1) {
      for (const item of list) {
        // 财务归档生效判断
        const warnflag = ArchiveEffectUtils.checkArchiveEffect(item)
        if (warnflag) {
          this.$message.warning(this._view.$t('CargoMsg.NOT_OPERATIONAL'))
          return
        }
      }
    }
    await this.updateProvisionedStateClickHandler(list, 0)
    // this.financeBtnGroupView.showCancelProvisionedDialog = true
    this.cancelProvisionedConfirmCB(null)
  }
  // 计提
  async provisionedClickHandler() {
    const list = [this.financeBtnGroupView.job]
    await this.updateProvisionedStateClickHandler(list, 1)
    this.financeBtnGroupView.showProvisionedDialog = true
  }

  /**
   * 计提弹框确认回调
   * @param provisionedDate
   * @returns {Promise<void>}
   */
  async provisionedConfirmCB(provisionedDate) {
    this.loading()
    await this.updateProvisionedConfirmCB([this.financeBtnGroupView.job.uuid], provisionedDate, 1).then(res => {
      this.financeBtnGroupView.showProvisionedDialog = false
      // this.$message.success('计提成功')
      this.refresh()
    }).finally(() => {
      this.closeLoading()
    })
  }

  /**
   * 取消计提确认
   * @param provisionedDate
   * @returns {Promise<void>}
   */
  async cancelProvisionedConfirmCB(provisionedDate) {
    this.loading()
    await this.updateProvisionedConfirmCB([this.financeBtnGroupView.job.uuid], provisionedDate, 0).then(res => {
      this.financeBtnGroupView.showCancelProvisionedDialog = false
      this.refresh()
    }).finally(() => {
      this.closeLoading()
    })
  }
  // 核对审核日期
  async checkAccountDate(accountDate) {
    const job = this.financeBtnGroupView.job
    await this.$confirm(new Date(job.businessDate) > accountDate ? this.$t('Message.TheApprovalDateIsEarlierThanTheBusinessDate') : this.$t('CargoMsg.Cargo_SureToReviewTheBills'), this.$t('CargoMsg.Cargo_Tips'), { type: 'warning' })
  }
  /* 改单审核*/
  checkChangeClickHandler() {
    // 财务归档生效判断
    const warnflag = ArchiveEffectUtils.checkArchiveEffect(this.financeBtnGroupView.job)
    if (warnflag) {
      this.$message.warning(this.$t('CargoMsg.NOT_OPERATIONAL'))
      return
    }
    if (this.financeBtnGroupView.job.changeState !== SystemConstants.CHANGE_COMMIT.code) {
      this.$message.warning(this.$t('Clearing.ThisIsNotIn') + SystemConstants.CHANGE_COMMIT.label + this.$t('Clearing.AllowedToReviewCheck'))
      return
    }
    if (this._view.jobAndChargeSubmitterAndAuditorCanNotSame && this.financeBtnGroupView.job.changeBy === this.$store.getters.userId) {
      this.$message.warning(this.$t('FinanceManage.ChargeSubmitNotAllowCancelChangeOrder'))
      return
    }
    this.financeBtnGroupView.showChangeDialog = true
  }

  async allowChangeClickHandler() {
    // 财务归档生效判断
    const warnflag = ArchiveEffectUtils.checkArchiveEffect(this.financeBtnGroupView.job)
    if (warnflag) {
      this.$message.warning(this.$t('CargoMsg.NOT_OPERATIONAL'))
      return
    }
    if (this._view.jobAndChargeSubmitterAndAuditorCanNotSame && this.financeBtnGroupView.job.commitUser === this.$store.getters.userId) {
      this.$message.warning(this.$t('FinanceManage.JobSubmitNotAllowCancelChangeOrder'))
      return
    }
    this.$confirm(this.$t('Clearing.ConfirmToAllowAmendments'), this.$t('CargoMsg.Cargo_Tips'), { type: 'warning' }).then(() => {
      this.loading()
      Job.updateChangeState([this.financeBtnGroupView.job.uuid], { changeState: SystemConstants.CHANGE_CANCHANGE.code, branchId: this.$store.getters.currentOfficeId, accountingDate: null, location: this._view.location }).then(res => {
        this.$message.success(this.$t('Clearing.AmendmentAllowedSuccessful'))
        this.refresh()
      }).finally(() => {
        this.closeLoading()
      })
    })
  }
  // 取消费用审核
  async cancelChargesAuditClickHandler() {
    const items = this._getSelectCharges(1)
    await Assert.isTrue(items.length > 0, this.$t('Clearing.NoOrNotInStatus'), 'warning')
    if (this._view.jobAndChargeSubmitterAndAuditorCanNotSame) {
      for (const charge of items) {
        if (charge.commitUser === this.$store.getters.userId) {
          this.$message.warning(this.$t('FinanceManage.ChargeSubmitNotAllowCancelAudit'))
          return
        }
      }
    }
    // 财务归档生效判断
    const warnflag = ArchiveEffectUtils.checkArchiveEffect(this.financeBtnGroupView.job)
    if (warnflag) {
      this.$message.warning(this.$t('CargoMsg.NOT_OPERATIONAL'))
      return
    }
    await this.$confirm(this.$t('CargoMsg.Cargo_SureToCancelVerification'), this.$t('CargoMsg.Cargo_Tips'), { type: 'warning' })

    const uuidAccountDateMap = {}
    for (const charge of items) {
      charge.chargeState = 2
      // todo 使用job对象model
      if (this.financeBtnGroupView.job.jobState < 2 || this.financeBtnGroupView.job.jobState === 13) {
        charge.accountingDate = null
      }
      uuidAccountDateMap[charge.uuid] = charge.accountingDate
      if (Object.prototype.hasOwnProperty.call(uuidAccountDateMap, 'jobUuid')) continue
      uuidAccountDateMap['jobUuid'] = charge.jobUuid
    }
    uuidAccountDateMap['location'] = this._view.location
    this.loading()
    batchUpdateChargeState(uuidAccountDateMap, 1).then(res => {
      this.$message.success(this.$t('Message.ExpenseStatusUpdatedSuccessfully'))
      this.refresh()
    }).finally(() => {
      this.closeLoading()
    })
    // todo 标记的操作来源node
    // Session.getInstance().clazzAndFunctionName(this, arguments.callee, 'btnChargeAuditCancelClickHandler'))
  }
  /* 费用审核*/
  async chargeAuditClickHandler() {
    const items = this._getSelectCharges(2)
    await Assert.isTrue(items.length > 0, this.$t('Clearing.NoOrNotInStatus4'), 'warning')
    if (this._view.jobAndChargeSubmitterAndAuditorCanNotSame) {
      for (const charge of items) {
        if (charge.commitUser === this.$store.getters.userId) {
          this.$message.warning(this.$t('FinanceManage.ChargeSubmitNotAllowAudit'))
          return
        }
      }
    }
    this.financeBtnGroupView.showChargeCheckDialog = true
  }

  /**
   * 费用审核回调
   * @param checkDate
   */
  chargeAuditConfirmCB(accountingDate) {
    const items = this._getSelectCharges(2)
    this.sapChargeList = []
    const uuidAccountDateMap = {}
    for (const charge of items) {
      charge.chargeState = 2
      //
      if (!charge.accountingDate) {
        charge.accountingDate = accountingDate
      }
      if (this.openHecConfig) {
        this.sapChargeList.push(charge)
      }
      uuidAccountDateMap[charge.uuid] = charge.accountingDate
      if (Object.prototype.hasOwnProperty.call(uuidAccountDateMap, 'jobUuid')) continue
      uuidAccountDateMap['jobUuid'] = charge.jobUuid
    }
    uuidAccountDateMap['location'] = this._view.location
    batchUpdateChargeState(uuidAccountDateMap, 2).then(res => {
      if (this.openHecConfig) {
        this.saveChargeAccountDateHandler(ChargeUtils.CHARGE_SH.code, ChargeUtils.CHARGE_PS1.code, true)
      } else {
        this.$message.success(this.$t('Message.ExpenseStatusUpdatedSuccessfully'))
        this.refresh()
      }
      this.financeBtnGroupView.showChargeCheckDialog = false
    })
    // todo 标记的操作来源node
    // Session.getInstance().clazzAndFunctionName(this, arguments.callee, 'chargeAccountDateCallBackHandler'))
  }

  /**
   * 获取选中费用
   */
  _getSelectCharges(chargeState) {
    const items = []
    if (!this._view || !this._view.$refs['tabCharges'] || this._view.$refs['tabCharges'] === undefined) {
      if (chargeState === 1) {
        this.$message.warning(this.$t('Clearing.NoOrNotInStatus3'))
      } else {
        this.$message.warning(this.$t('Clearing.NoOrNotInStatus4'))
      }
      return
    }
    const chooseCharges = this._view.$refs['tabCharges'].tabChargesHP.getAllSelectedRows(false)
    for (const charge of chooseCharges) {
      if (chargeState === 2 ? charge.chargeState === 1 : charge.chargeState === 2) {
        items.push(charge)
      }
    }
    return items
  }
  // 取消财务审核
  async cancelAuditClickHandler() {
    // 财务归档生效判断
    const warnflag = ArchiveEffectUtils.checkArchiveEffect(this.financeBtnGroupView.job)
    if (warnflag) {
      this.$message.warning(this.$t('CargoMsg.NOT_OPERATIONAL'))
      return
    }
    if (this._view.jobAndChargeSubmitterAndAuditorCanNotSame && this.financeBtnGroupView.job.commitUser === this.$store.getters.userId) {
      this.$message.warning(this.$t('FinanceManage.JobSubmitNotAllowCancelAudit'))
      return
    }
    const hasGenerateVoucher = await checkCancelAudit({ keys: [this.financeBtnGroupView.job.uuid] }).then(res => res.data)
    if (hasGenerateVoucher) { // 已生成凭证【当前业务含有已生成凭证的费用】
      const allowCancelApprove = Number(cache.config.get('AllowCancelApprove')) === 1
      if (allowCancelApprove) {
        await this.$confirm(this.$t('Message.BusinessHasGeneratedVouchers') + this.$t('Message.AreYouSureYouWantToCancelTheApproval'), this.$t('CargoMsg.Cargo_Tips'), { type: 'warning' })
      } else {
        this.$message.warning(this.$t('Message.BusinessHasGeneratedVouchers') + this.$t('Message.UnableCancelAudit'))
        return
      }
    } else {
      await this.$confirm(this.$t('Message.AreYouSureYouWantToCancelTheApproval'), this.$t('CargoMsg.Cargo_Tips'), { type: 'warning' })
    }
    const flag = await this.wkVerifyRollbackPushFunc()
    if (flag) {
      Job.jobSingleAccountVerifyRollback([this.financeBtnGroupView.job.uuid], this.$store.getters.currentOfficeId, this._view.location).then(res => {
        this.$message.success(this.$t('CargoMsg.Cargo_ReviewCancelledSuccessfully'))
        this.refresh()
      })
    }
  }
  async checkCancelAuditClickHandler(auditDialog) {
    // 财务归档生效判断
    const warnflag = ArchiveEffectUtils.checkArchiveEffect(this.financeBtnGroupView.job)
    if (warnflag) {
      this.$message.warning(this.$t('CargoMsg.NOT_OPERATIONAL'))
      auditDialog.visible = false
      return
    }
    if (this._view.jobAndChargeSubmitterAndAuditorCanNotSame && this.financeBtnGroupView.job.commitUser === this.$store.getters.userId) {
      this.$message.warning(this.$t('FinanceManage.JobSubmitNotAllowCancelAudit'))
      auditDialog.visible = false
      return
    }
    const hasGenerateVoucher = await checkCancelAudit({ keys: [this.financeBtnGroupView.job.uuid] }).then(res => res.data)
    if (hasGenerateVoucher) { // 已生成凭证【当前业务含有已生成凭证的费用】
      const allowCancelApprove = Number(cache.config.get('AllowCancelApprove')) === 1
      if (allowCancelApprove) {
        await this.$confirm(this.$t('Message.BusinessHasGeneratedVouchers') + this.$t('Message.AreYouSureYouWantToCancelTheApproval'), this.$t('CargoMsg.Cargo_Tips'), { type: 'warning' })
      } else {
        this.$message.warning(this.$t('Message.BusinessHasGeneratedVouchers') + this.$t('Message.UnableCancelAudit'))
        auditDialog.visible = false
        return
      }
    }
    auditDialog.visible = true
  }
  async cancelAuditClickRejectReasonHandler(rejectReason) {
    const flag = await this.wkVerifyRollbackPushFunc()
    if (flag) {
      this.loading()
      Job.jobSingleAccountVerifyRollback([this.financeBtnGroupView.job.uuid], this.$store.getters.currentOfficeId, this._view.location, rejectReason).then(res => {
        this.$message.success(this.$t('CargoMsg.Cargo_ReviewCancelledSuccessfully'))
        this.refresh()
      }).finally(() => {
        this.closeLoading()
      })
    }
  }
  async wkVerifyRollbackPushFunc() {
    var flag = true
    if (cache.config.get('ToExoSystem') === 'WK') {
      console.log('this.financeBtnGroupView.job', this.financeBtnGroupView.job)
      // 过滤推送状态为“已发送”/“修改待发送”的数据
      if (this.financeBtnGroupView.job.pushStatus > 0) {
        flag = false
        const params = {
          dataKeys: [this.financeBtnGroupView.job.uuid],
          branchId: this.$store.getters.currentOfficeId,
          userId: this.$store.getters.userId
        }
        this.loading()
        await wkVerifyRollbackPush(params).then(async r => {
          if (r.data) {
            const pushResult = r.data
            // 系统返回的错误提示信息
            const errorMsg = pushResult.errorMsg
            if (errorMsg && errorMsg.length > 0) {
              this.$message.error(errorMsg)
              return flag
            }
            // 接口提示
            const msg = pushResult.resultMsg
            // 失败的uuid集合
            // if (pushResult.failureKeys && pushResult.failureKeys.length > 0) {
            //   msg += '：/n' + pushResult.failureKeys.join('/n')
            // }
            // 成功则调用取消财务审核接口
            if (pushResult.success && pushResult.successKeys && pushResult.successKeys.length > 0) {
              await Job.jobSingleAccountVerifyRollback(pushResult.successKeys, this.$store.getters.currentOfficeId, this._view.location).then(res => {
                this.$message.success(msg)
                this.refresh()
              })
            } else {
              this.$message.warning(msg)
            }
          }
        }).finally(() => {
          this.closeLoading()
        })
      }
    }
    return flag
  }
  // 审核
  async auditClickHandler() {
    if (this.financeBtnGroupView.job.lclMasterUuid && this.allSubmitFcl) {
      this.$message.warning(this.$t('FinanceManage.LclTicketsCanNotAudit'))
      return
    }
    if (this._view.jobAndChargeSubmitterAndAuditorCanNotSame && this.financeBtnGroupView.job.commitUser === this.$store.getters.userId) {
      this.$message.warning(this.$t('FinanceManage.JobSubmitNotAllowAudit'))
      return
    }
    await cache.load(cacheName.CONFIG)
    this.financeBtnGroupView.editApprovalDate = Number(cache.config.get('isAllowEditApprovalDate')) === 1
    // 判断是否开启验证规则
    const opOffice = this.financeBtnGroupView.job ? this.financeBtnGroupView.job.opOffice : 0
    const hasCheckRule = await JobUtils.hasCheckRuleCondition(this._view.financeDetailHp.useCheckRule, 13, opOffice)
    if (this._view.financeDetailHp.useCheckRule && hasCheckRule) {
      this.financeBtnGroupView.showCheckDialog = false
      const callBack = this.showFinanceBtnGroupViewCall
      const callBack2 = null
      this.checkingManager(13, callBack, callBack2)
    } else {
      this.showFinanceBtnGroupView()
    }
  }
  showFinanceBtnGroupViewCall() {
    return true
  }
  showFinanceBtnGroupView() {
    this.financeBtnGroupView.checkDialog.poNo = this.financeBtnGroupView.job.poNo
    this.financeBtnGroupView.checkDialog.isEditable = false
    this.financeBtnGroupView.showCheckDialog = true
  }

  async batchCheckChangeConfirmCB(accountDate) {
    await super.batchCheckChangeConfirmCB([this.financeBtnGroupView.job.uuid], accountDate, this._view.location)
  }
  async batchAuditConfirmCB({ accountDate, poNo }) {
    await super.batchAuditConfirmCB([this.financeBtnGroupView.job.uuid], accountDate, poNo, true, this._view.location)
  }

  async batchAuditConfirmSuccessCB(res) {
    if (res === 'ok') {
      this.$message.success(this._view.$t('FinanceManage.AccountVerifyBusinessSuccess'))
    } else if (res === 'repeatClick') {
      this.$message.warning(this._view.$t('Message.RepeatClickJobAccountVerify'))
    } else if (res === 'asyncDo') {
      this.$message.success(this._view.$t('Message.AsynchronousJobAccountVerify'))
    } else {
      if (res.jinRongExchange) {
        this.$message.success(this._view.$t('FinanceManage.SyncCloudSucceededXFailedX', [res.jinRongExchange.successCount, res.jinRongExchange.failCount]))
      } else {
        this.$message.success(this._view.$t('CargoMsg.Cargo_AuditSuccessfully'))
      }
    }
  }

  async batchAuditConfirmFailCB() {
    this.$message.warning(this.$t('Clearing.ReviewFailed'))
  }
  updateResultProvisioned() {
    //

  }
  updateDefaultMenuState() {
    // 在 btnGroup.vue中实现
    this.refresh()
  }
  async beforeMount() {
    await super.beforeMount()
  }

  // 改单提交
  async btnChargeCommitButtonClick() {
    const chargeKeys = []
    this.sapChargeList = []
    if (this._view.job.lob === 'SE') {
      await new SeaExportJob(this._view.job).getCharges()
    }
    for (const charge of this._view.job.charges) {
      if (charge.adjustment) {
        charge.sapStatus = ChargeUtils.CHARGE_MS.code
        this.sapChargeList.push(charge)
        chargeKeys.push(charge.uuid)
      }
    }
    if (chargeKeys.length > 0) {
      updateSapStatus(chargeKeys, ChargeUtils.CHARGE_MS.code).then(res => {
        this.btnChargeCommitButtonClickSuccess(res)
      }).catch((err) => {
        this.$message(this.$t('Clearing.FrontEndErrorCallbackFailed') + err)
      })
    } else {
      this.$message.warning(this.$t('Message.ChangeOrderSubmissionFailed'))
    }
  }

  btnChargeCommitButtonClickSuccess(res) {
    this.saveChargeAccountDateHandler('', ChargeUtils.CHARGE_MS.code, false)
  }

  saveChargeAccountDateHandler(oldSapStatus, sapStatus, updateCharge) {
    this.$message.success(this.$t('Message.ExpenseStatusUpdatedSuccessfully'))
    if (this.sapChargeList != null && this.sapChargeList.length > 0 && this.openHecConfig) {
      // 发送更新sap费用消息
      const chargeKeys = Array.from(this.sapChargeList, p => p.uuid)
      if (this.openHecConfig) {
        sendHecMessageByCharge(chargeKeys, oldSapStatus, sapStatus, updateCharge, true).then(res => {
          this.sendSapSuccess(res)
        }).catch((err) => {
          this.$message('前端error：回调失败' + err)
        })
      }
    } else {
      this.refresh()
    }
  }

  sendSapSuccess(res) {
    let r = 'failure'
    if (res && Number(res.data) > 0) {
      r = 'success'
      this.$message.success(this.$t('Message.SapSynchronizationSuccess'))
    } else {
      this.$message.warning(this.$t('Message.SapSynchronizationFault'))
    }
    this.refresh()
    this.$logger.log('chargeInfo sendSapSuccess key: ' + this._view.job.uuid + ' result:  ' + r)
  }

  /**
   * 单个计提（详情使用，可todo del）
   *
   */
  btnIsProvisionedClickHandler() {

    // todo
    // super.btnIsProvisionedClickHandler()
    // var jobs:ArrayCollection = new ArrayCollection();
    // if (_job.isProvisioned)
    // {
    //  MessageDialog.info("此业务已计提,不能重复计提!");
    //  return;
    // }
    // else
    //  jobs.addItem(job.key);
    //
    // if(jobs.length>0)
    // {
    //  if(financeProvisioned == null)
    //  {
    //   financeProvisioned  = new FinanceProvisioned();
    //  }
    //  financeProvisioned.isEditable = true;
    //  PopUpManager.addPopUp(financeProvisionedthis._view,true);
    //  PopUpManager.centerPopUp(financeProvisioned);
    //  financeProvisioned.callback =
    //   function (provisionedDate:Date):void
    //   {
    //    Job.updateProvisioned(jobs,provisionedDate,1,new Responder(updateResultProvisioned,failureHandler));
    //   };
    // }
  }

  /**
   * 取消计提
   *
   */
  btnIsAwayProvisionedClickHandler() {
    // todo

    // var jobs:ArrayCollection = new ArrayCollection();
    // if (!_job.isProvisioned)
    // {
    //  MessageDialog.info("此业务未计提,不能重复取消计提!");
    //  return;
    // }
    // else
    //  jobs.addItem(job.key);
    //
    // if(jobs.length>0)
    // {
    //  Job.updateProvisioned(jobs,null,0,new Responder(updateResultProvisioned,failureHandler));
    // }
  }

  created() {
    this._view.gridOptions = {
      rowSelection: 'multiple',
      treeData: true,
      groupDefaultExpanded: 2,
      getDataPath: data => {
        return data.path.split(',')
      },
      autoGroupColumnDef: {
        headerName: this.view.leftGridColumnType === 'jobNo' ? this.$t('SeaExport.BusinessNo') : this.view.leftGridColumnType,
        field: this.view.leftGridColumnType,
        colId: this.view.leftGridColumnType,
        tooltip: (params) => {
          return params.data ? params.data[this.view.leftGridColumnType] : ''
        },
        width: 160,
        headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        cellRendererParams: {
          suppressCount: true,
          suppressDoubleClickExpand: false,
          checkbox: params => {
            return false
          },
          innerRenderer: params => {
            return params.value
          }
        }
      },
      onCellClicked: event => {
        this._view.handleCellFocused(event)
        this._view.selectedJob = event.data
        if (!this._view.selectedJob) {
          this._view.selectedJob = this.readSelectedRows()[0]
        }
      },
      suppressContextMenu: false,
      getContextMenuItems: () => {
        const self = this.view
        const menu = [
          {
            name: this.$t('SeaExport.BusinessNo'),
            action: function() {
              const currentUserInfo = getUserInfo()
              self.leftGridColumnType = 'jobNo'
              window.localStorage.setItem(`FI_LEFT_GRID_TYPE_${currentUserInfo.tenantId}_${currentUserInfo.userId}`, 'jobNo')
            }
          }, {
            name: this.$t('SeaExport.Mbl2'),
            action: function() {
              self.leftGridColumnType = 'mbl'
              const currentUserInfo = getUserInfo()
              window.localStorage.setItem(`FI_LEFT_GRID_TYPE_${currentUserInfo.tenantId}_${currentUserInfo.userId}`, 'mbl')
            }
          }, {
            name: this.$t('SeaExport.Hbl2'),
            action: function() {
              self.leftGridColumnType = 'hblNb3'
              const currentUserInfo = getUserInfo()
              window.localStorage.setItem(`FI_LEFT_GRID_TYPE_${currentUserInfo.tenantId}_${currentUserInfo.userId}`, 'hblNb3')
            }
          }
        ]
        return menu
      }
    }
  }

  // 打印
  printHandler() {
    if (this._view.activeTabName !== 'tabInternalBill' && this._view.activeTabName !== 'tabOverseaBill') {
      // printChecked
      const params = {}
      let category = ''
      if (this._view.job.lob === 'SE') {
        category = 'BOOKING'
      } else if (this._view.job.lob === 'SI') {
        category = 'SIJOBNO'
      } else if (this._view.job.lob === 'AE') {
        category = 'AEBOOKING'
      } else {
        category = 'AIJOBNO'
      }
      params.jobuuid = this._view.job.uuid
      params.JOB_UUID = this._view.job.uuid
      // TemplateSelectorWin.getInstance().showThisWin(_job, category, params, this)
      this._view.templateSelectorDialog.cxt = this._view.job
      this._view.templateSelectorDialog.category = category
      this._view.templateSelectorDialog.data = params
      this._view.templateSelectorDialog.visible = true
      return
    }
    this.$nextTick(async() => {
      // 每个页签的参数
      const params = await this.$refs[this._view.activeTabName].getPrintData() || null
      if (!params) return
      // 公共参数
      if (!Object.prototype.hasOwnProperty.call(params, 'jobuuid') || !params.jobuuid) {
        params.jobuuid = this._view.job.uuid
      }
      if (!Object.prototype.hasOwnProperty.call(params, 'JOB_UUID') || !params.JOB_UUID) {
        params.JOB_UUID = this._view.job.uuid
      }
      console.log('---params--', params)
      this._view.templateSelectorDialog.ctx = Object.prototype.hasOwnProperty.call(params, 'ctx') ? params.ctx : null
      if (Object.prototype.hasOwnProperty(params, 'ctx')) delete params.ctx
      this._view.templateSelectorDialog.category = params.category
      this._view.templateSelectorDialog.data = params
      // 组装打印回调函数
      await this._view.onPrintCallback(params)
      this._view.templateSelectorDialog.visible = true
    })
  }
  /**
   * 利润打印
   * @public
   */
  async profitPrintClickHandler() {
    if (this._view.job.lob === 'SE') {
      const exportJob = this._view.job
      // 整箱
      if (exportJob != null && !exportJob.masterFlag && (exportJob.containerLoadType === ContainerLoadType.FCL_CARGO_TYPE.code || exportJob.containerLoadType === ContainerLoadType.BB_CARGO_TYPE.code ||
          exportJob.containerLoadType === ContainerLoadType.SPECIAL_CARGO_TYPE.code || exportJob.containerLoadType === ContainerLoadType.BULK_CARGO_TYPE.code)) {
        await this.checkPrintEnable(this._view, this.doPrintFCLPROFIT)
      }
      // 拼箱主票
      if (exportJob !== null && exportJob.masterFlag) {
        await this.checkPrintEnable(this._view, this.doPrintLCLPROFIT)
      }
    } else if (this._view.job.lob === 'SI') {
      const importJob = this._view.job
      if (importJob != null && !importJob.masterFlag && (importJob.containerLoadType !== ContainerLoadType.LCL_CARGO_TYPE.code)) {
        // 整箱打印
        await this.checkPrintEnable(this._view, this.doPrintFCLPROFIT)
      } else {
        // 拼箱打印
        await this.checkPrintEnable(this._view, this.doPrintLCLPROFIT)
      }
    } else if (this._view.job.lob === 'AI') {
      await this.checkPrintEnable(this._view, this.doPrintAiImport)
    } else {
      await this.checkPrintEnable(this._view, this.doPrintAiExport)
    }
  }

  /**
   * 确认是否可打印
   */
  async checkPrintEnable(view, callback) {
    // 组装打印回调函数
    // await this._view.onPrintCallback()
    if (this._view.job && !this._view.job.masterFlag && Number(this._view.job.sales) <= 0 && this._view.job.cargoSource !== CargoSource.NC_CARGO_SOURCE.code) {
      this.$message.warning('请录入销售人员信息再打印！')
    } else if (this._view.job && this._view.job.masterFlag) {
      if (this._view.job.uuid && (!this._view.job.lclSlaves || this._view.job.lclSlaves.length <= 0)) {
        this._view.job.lclSlaves = await new Job(this._view.job).getLclSlaves()
      }
      this.loadLclResult(callback, view)
    } else if (this._view.job && !this._view.job.masterFlag) {
      callback(view)
    }
  }
  /**
   * 整箱
   *  @private
   */
  doPrintFCLPROFIT(view) {
    const params = {}
    params.jobuuid = view.job.uuid
    params.JOB_UUID = view.job.uuid
    let category = ''
    if (view.job.lob === 'SI') {
      category = 'SIFCLPROFIT'
    } else {
      category = 'FCLPROFIT'
    }
    // TemplateSelectorWin.getInstance().showThisWin(_job, category, params, financeView, doPrintPROFIT);
    view.templateSelectorDialog.ctx = new Job(view.job)
    view.templateSelectorDialog.category = category
    view.templateSelectorDialog.data = params
    // 组装打印回调
    view.prePrintCallback = view.doPrintPROFIT
    view.templateSelectorDialog.visible = true
  }

  /**
   * 拼箱
   * @private
   */
  doPrintLCLPROFIT(view) {
    const params = {}
    params.jobuuid = view.job.uuid
    params.JOB_UUID = view.job.uuid
    // TemplateSelectorWin.getInstance().showThisWin(_job, "LCLPROFIT", params, financeView, doPrintPROFIT);
    view.templateSelectorDialog.ctx = new Job(view.job)
    view.templateSelectorDialog.category = 'LCLPROFIT'
    view.templateSelectorDialog.data = params
    // 组装打印回调
    view.prePrintCallback = view.doPrintPROFIT
    view.templateSelectorDialog.visible = true
  }

  doPrintAiImport(view) {
    const category = view.job.operateType === ImportConstants.CONSOLE.code ? 'AIPROFIT_PP' : 'AIPROFIT'
    // TemplateSelectorWin.getInstance().showThisWin(_job, category, {"JOB_UUID" : _job.key}, financeView, doPrintPROFIT);
    view.templateSelectorDialog.ctx = new Job(view.job)
    view.templateSelectorDialog.category = category
    view.templateSelectorDialog.data = { 'JOB_UUID': view.job.uuid, 'jobuuid': view.job.uuid }
    // 组装打印回调
    view.prePrintCallback = view.doPrintPROFIT
    view.templateSelectorDialog.visible = true
  }

  doPrintAiExport(view) {
    const category = view.job.operateType === AirExportConstants.CONSOLE.code ? 'AEPROFIT2' : 'AEPROFIT'
    // TemplateSelectorWin.getInstance().showThisWin(_job, category, {"JOB_UUID" : _job.key}, financeView, doPrintPROFIT);
    view.templateSelectorDialog.ctx = new Job(view.job)
    view.templateSelectorDialog.category = category
    view.templateSelectorDialog.data = { 'JOB_UUID': view.job.uuid, 'jobuuid': view.job.uuid }
    // 组装打印回调
    view.prePrintCallback = view.doPrintPROFIT
    view.templateSelectorDialog.visible = true
  }
  /**
   * 加载用量成功
   */
  loadLclResult(callback, view) {
    const jobNos = []
    if (this._view.job.lclSlaves != null && this._view.job.lclSlaves.length > 0) {
      for (const job of this._view.job.lclSlaves) {
        if (job.sales <= 0 && job.cargoSource !== CargoSource.NC_CARGO_SOURCE.code) {
          jobNos.push(job.jobNo)
        }
      }
      if (jobNos.length > 0) {
        this.$message.warning('以下几单没有输入销售人员信息：\n' + jobNos.join('\n') + '\n请输入后再打印！')
      } else {
        callback(view)
      }
    }
  }
  // 验证规则配置公用
  checkingManager(checkNode, callBack, callBack2) {
    if (!this.financeBtnGroupView.job) return
    this.financeBtnGroupView.checkingWindow.job = this.financeBtnGroupView.job
    this.financeBtnGroupView.checkingWindow.callBack = callBack
    this.financeBtnGroupView.checkingWindow.callBack2 = callBack2
    this.financeBtnGroupView.checkingWindow.visible = true
  }
  // 更新汇率
  updateExchangeRate() {
    // 财务归档生效判断
    const warnflag = ArchiveEffectUtils.checkArchiveEffect(this.financeBtnGroupView.job)
    if (warnflag) {
      this.$message.warning(this.$t('CargoMsg.NOT_OPERATIONAL'))
      return
    }
    this._view.updateExchangeRateDialog.jobKeyList = [this._view.job.uuid]
    this._view.updateExchangeRateDialog.visible = true
  }
}
